import React from 'react'
import { appUrl } from '../runtime'

// Replaces `next/link` in the widget build. The casino can't use Next's client router, so a
// link is just an anchor to core's frontend origin (a full-page navigation, which is correct
// for cross-origin links anyway). Next-only props are dropped.
type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string
  prefetch?: boolean
  replace?: boolean
  scroll?: boolean
  shallow?: boolean
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { href, prefetch, replace, scroll, shallow, children, ...rest },
  ref,
) {
  void prefetch
  void replace
  void scroll
  void shallow
  return (
    <a ref={ref} href={appUrl(href)} {...rest}>
      {children}
    </a>
  )
})

export default Link
